import MainContent from '../../../layouts/maincontent/MainContent';
import Lottie from 'react-lottie';
import Page404 from '../../../lotties/404.json';
import styleNotFound from './NotFound.module.css';
const NotFound = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    speed: 1,
    animationData: Page404,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
  };
  return (
    <MainContent>
      <section className={ styleNotFound["notFound-section"] }>
        <div className="container">
          <div className="row justify-content-center pt-5">
            <div className="col-md-5">
              <div className={ `card ${styleNotFound["card"]}` }>
                <div className="text-center pt-5">
                  <Lottie
                    width='50%'
                    options={ defaultOptions }
                  />
                </div>
                <div className={ `${styleNotFound["card-body"]} card-body pb-5` }>
                  <h1 className={ `${styleNotFound.order_message} text-center mt-5 fw-bolder` }>هذه الصفحة غير متوفرة</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section >
    </MainContent >
  );
};

export default NotFound;